import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import api from '~/services/api';

import { saveCashFlowStatementFailure, saveCashFlowStatementSuccess } from './actions';

export function* saveCashFlowStatement({ payload }) {
  try {
    yield call(api.post, `api/cash-flow-statement`, payload.data, { withCredentials: true });

    yield put(saveCashFlowStatementSuccess());

    toast.success('Demonstração do fluxo de caixa atualizado com sucesso!');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(saveCashFlowStatementFailure());
  }
}

export default all([
  takeLatest('@cashFlowStatement/SAVE_REQUEST', saveCashFlowStatement),
]);